<div 
    class="fms-walk-me-check-item-row"
    [ngClass]="{ 'fms-walk-me-check-item-row-active': active, 'fms-walk-me-step-clickable': enable || checked }"
    (click)="setStep()"
    [attr.data-fms-heap]="'walk-me-modal-go-to-step-' + step"
>
    <svg *ngIf="checked" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_17928_204716)">
        <rect y="0.5" width="20" height="20" rx="4" style="fill: var(--vng-color-accent)"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3167 6.40446C15.5076 6.5794 15.5205 6.87591 15.3455 7.06675L8.47054 14.5667C8.38415 14.661 8.26301 14.7159 8.13518 14.7186C8.00736 14.7214 7.88395 14.6719 7.79354 14.5815L4.66854 11.4565C4.48549 11.2734 4.48549 10.9766 4.66854 10.7935C4.8516 10.6105 5.1484 10.6105 5.33146 10.7935L8.11028 13.5724L14.6545 6.43326C14.8294 6.24242 15.1259 6.22953 15.3167 6.40446Z" fill="white" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_17928_204716">
        <rect y="0.5" width="20" height="20" rx="10" fill="white"/>
        </clipPath>
        </defs>
    </svg>
        
    <svg *ngIf="!checked" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="1" width="19" height="19" rx="9.5" stroke="#808080"/>
    </svg>
    <span [ngClass]="{ 'fms-walk-me-check-item-row-active': active }"
        >{{ label }}<span *ngIf="required" class="fms-walk-me-required-asterisk" aria-label="required">*</span></span
    >
</div>
